import { create } from 'zustand';

interface CompanyStore {
  companyName: string | undefined;
  setCompanyName: (name: string | undefined) => void;
}

export const useCompanyStore = create<CompanyStore>((set) => ({
  companyName: localStorage.getItem('selectedCompany') || undefined,
  setCompanyName: (name: string | undefined) => {
    if (name) {
      localStorage.setItem('selectedCompany', name);
    } else {
      localStorage.removeItem('selectedCompany');
    }
    set({ companyName: name });
  },
}));
